export default __webpack_public_path__ + "static/media/HK.16b893ce.svg";